module.exports = "<div class=\"single-video\">\n    <h2 class=\"video-title\">{{$ctrl.video.snippet.title}}</h2>\n    <h3>\n        <small>{{$ctrl.video.snippet.publishedAt | date}}</small>\n    </h3>\n\n    <div class=\"embed-responsive embed-responsive-16by9\">\n        <youtube-video class=\"embed-responsive-item\"\n                       video-id=\"$ctrl.video.id.videoId\"></youtube-video>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/apps/videoItem/videoItem.html
// module id = 569
// module chunks = 0